import { Elements } from "@stripe/react-stripe-js";
import { getStripePublishableKey } from "./utils/getStripePublishableKey/getStripePublishableKey";
import { loadStripe } from "@stripe/stripe-js";
import React from "react";
import { StripeIntegration } from "../../../AppDataProvider/AppDataProvider";
import { StripePaymentForm } from "./StripePaymentForm/StripePaymentForm";
export type StripePaymentProps = {
  onGoBack: () => void;
  onPayAndBook: (bookingIds: string[]) => void;
  stripeIntegration: StripeIntegration;
};
export function StripePayment({
  onGoBack,
  onPayAndBook,
  stripeIntegration
}: StripePaymentProps): React.ReactElement {
  const stripePromise = loadStripe(getStripePublishableKey(), {
    stripeAccount: stripeIntegration?.accountId
  });
  return <Elements stripe={stripePromise} data-sentry-element="Elements" data-sentry-component="StripePayment" data-sentry-source-file="StripePayment.tsx">
      <StripePaymentForm onGoBack={onGoBack} onPayAndBook={onPayAndBook} data-sentry-element="StripePaymentForm" data-sentry-source-file="StripePayment.tsx" />
    </Elements>;
}
export default StripePayment;